/* PER-74 — instant, flicker-free quantity updates on the /cart page.
   The theme's cart.js re-renders the entire line (incl. the qty input) on every
   server response, so rapid clicks on a slow connection flash old values
   ("5 → 2 → 5"). This layer, scoped to the cart PAGE only (the side-cart drawer
   keeps using cart.js untouched):
     • intercepts qty changes in capture phase + stopImmediatePropagation so
       cart.js never double-handles them,
     • the number updates instantly (quantity-input already stepped it),
     • debounces to ONE /cart/change.js per line, ignoring stale responses,
     • on response updates ONLY the prices + Order Summary — never the qty input,
       so it can't revert/flicker.
*/
(function () {
  if (window.__pcpQtyInstant) return;
  var ITEMS = document.getElementById('main-cart-items');
  if (!ITEMS) return;
  window.__pcpQtyInstant = true;

  var timers = {};
  var seq = 0;
  var applied = 0;

  function sectionList() {
    var footer = document.getElementById('main-cart-footer');
    var list = [{ id: 'main-cart-items', section: ITEMS.dataset.id, selector: '.js-contents' }];
    if (footer) list.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
    list.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    return list;
  }

  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  // Update prices for each line from the freshly rendered items section WITHOUT
  // touching the quantity inputs (that's what prevents the flicker).
  function syncPrices(doc) {
    ITEMS.querySelectorAll('.cart-item').forEach(function (row) {
      var src = doc.getElementById(row.id);
      if (!src) return;
      row.querySelectorAll('.cart-item__totals').forEach(function (cell, i) {
        var srcCell = src.querySelectorAll('.cart-item__totals')[i];
        if (srcCell) cell.innerHTML = srcCell.innerHTML;
      });
    });
  }

  function applyFooter(doc, footerHtml) {
    var live = document.getElementById('main-cart-footer');
    if (!live) return;
    var liveInner = live.querySelector('.js-contents');
    var srcInner = parse(footerHtml).querySelector('.js-contents');
    if (liveInner && srcInner) liveInner.innerHTML = srcInner.innerHTML;
  }

  function pulse(row, on) {
    row.querySelectorAll('.cart-item__totals').forEach(function (c) {
      c.style.transition = 'opacity .15s ease';
      c.style.opacity = on ? '0.45' : '';
    });
  }

  function sync(line, qty, row) {
    var mySeq = ++seq;
    var list = sectionList();
    var body = JSON.stringify({
      line: parseInt(line, 10),
      quantity: qty,
      sections: list.map(function (s) { return s.section; }),
      sections_url: window.location.pathname,
    });
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (mySeq < applied) return; // a newer change already won
        applied = mySeq;
        if (state && state.sections) {
          var itemsId = ITEMS.dataset.id;
          var footerEl = document.getElementById('main-cart-footer');
          if (state.item_count === 0 || ITEMS.querySelectorAll('.cart-item').length !== state.items.length) {
            // line removed / count changed → full items re-render is needed
            var inner = parse(state.sections[itemsId]).querySelector('.js-contents');
            var liveInner = ITEMS.querySelector('.js-contents');
            if (inner && liveInner) liveInner.innerHTML = inner.innerHTML;
          } else if (state.sections[itemsId]) {
            syncPrices(parse(state.sections[itemsId]));
          }
          if (footerEl && state.sections[footerEl.dataset.id]) applyFooter(null, state.sections[footerEl.dataset.id]);
        }
        var bubble = document.querySelector('[data-header-cart-count], #count_counting');
        if (bubble && state && typeof state.item_count !== 'undefined') bubble.textContent = state.item_count;
        refreshDrawer(); // keep the side-cart drawer in sync (we bypassed cart.js)
        if (row) pulse(row, false);
      })
      .catch(function () { if (row) pulse(row, false); });
  }

  /* Because we bypass cart.js, the side-cart drawer never hears about the change.
     Re-render it (fresh, cache-busted) so its quantities/prices stay in sync. */
  function refreshDrawer() {
    if (!document.querySelector('cart-drawer-items')) return;
    fetch(window.location.pathname + '?section_id=cart-drawer&__pcp=' + (new Date().getTime()), { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = parse(html);
        ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
          var live = document.querySelector(sel);
          var src = doc.querySelector(sel);
          if (live && src) live.replaceWith(src);
        });
      })
      .catch(function () {});
  }

  ITEMS.addEventListener(
    'change',
    function (e) {
      var input = e.target;
      if (!input.classList || !input.classList.contains('quantity__input')) return;
      e.stopImmediatePropagation(); // bypass cart.js entirely
      var line = input.getAttribute('data-index');
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) return;
      var row = input.closest('.cart-item');
      if (row) pulse(row, true);
      clearTimeout(timers[line]);
      timers[line] = setTimeout(function () { sync(line, qty, row); }, 300);
    },
    true // capture: runs before cart-items' bubble listener
  );

  /* Gift-wrap / gift-box: cart-gift.js mutates the cart then calls the theme's
     ShopUtils.cartRefresh, but that does a plain GET ?section_id= which the
     browser caches → the summary updates one action behind ("add" shows nothing,
     "remove" shows the add). Re-fetch the summary FRESH (no-store + cache-bust)
     after the gift commits. Two passes cover slow responses. */
  function refreshSummaryFresh() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer) return;
    var url = window.location.pathname + '?section_id=' + footer.dataset.id + '&__pcp=' + (new Date().getTime());
    fetch(url, { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var liveInner = footer.querySelector('.js-contents');
        var srcInner = parse(html).querySelector('.js-contents');
        if (liveInner && srcInner) liveInner.innerHTML = srcInner.innerHTML;
      })
      .catch(function () {});
  }
  var giftTimer1, giftTimer2;
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('.gift_enables_page, #giftbag-checkbox-page, #giftbox-checkbox-page, [name="giftbag"], [name="giftbox"]')) {
      clearTimeout(giftTimer1); clearTimeout(giftTimer2);
      giftTimer1 = setTimeout(refreshSummaryFresh, 600);
      giftTimer2 = setTimeout(refreshSummaryFresh, 1600); // safety for slow add/remove
    }
  });

  /* Promo code apply → Shopify's /discount/<code> route applies the code and
     redirects back to /cart (the storefront way to apply a code from the cart). */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-cart-promo]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('.cart-amp__promo-input');
    var code = ((input && input.value) || '').trim();
    if (!code) { if (input) input.focus(); return; }
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  });
})();
